(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.best-seller-section').forEach(function(section) {
      var sectionId = section.getAttribute('data-section-id');
      if (!sectionId) return;
      
      var carousel = document.getElementById('best-seller-carousel-' + sectionId);
      var prevBtn = document.getElementById('best-seller-prev-' + sectionId);
      var nextBtn = document.getElementById('best-seller-next-' + sectionId);
      var dotsContainer = document.getElementById('best-seller-dots-' + sectionId);
      
      if (!carousel) return;
      
      var cards = carousel.querySelectorAll('.best-seller-card');
      if (cards.length === 0) return;
      
      // ===== Get card width including gap =====
      function getCardWidth() {
        var firstCard = carousel.querySelector('.best-seller-card');
        if (!firstCard) return 200;
        var style = window.getComputedStyle(firstCard);
        var marginLeft = parseFloat(style.marginLeft) || 0;
        var marginRight = parseFloat(style.marginRight) || 0;
        var gap = parseFloat(window.getComputedStyle(carousel).gap) || 0;
        return firstCard.offsetWidth + gap;
      }
      
      // ===== Get visible cards count =====
      function getVisibleCards() {
        var firstCard = carousel.querySelector('.best-seller-card');
        if (!firstCard) return 4;
        var cardWidth = firstCard.offsetWidth + parseFloat(window.getComputedStyle(carousel).gap) || 0;
        var containerWidth = carousel.clientWidth;
        return Math.round(containerWidth / cardWidth);
      }
      
      // ===== Get total pages =====
      function getTotalPages() {
        var visible = getVisibleCards();
        return Math.max(1, Math.ceil(cards.length / visible));
      }
      
      // ===== Get current page =====
      function getCurrentPage() {
        var cardWidth = getCardWidth();
        var scrollPos = carousel.scrollLeft;
        var visible = getVisibleCards();
        var page = Math.round(scrollPos / (cardWidth * visible));
        return Math.max(0, Math.min(getTotalPages() - 1, page));
      }
      
      // ===== Scroll to page =====
      function scrollToPage(page) {
        var cardWidth = getCardWidth();
        var visible = getVisibleCards();
        var scrollAmount = page * cardWidth * visible;
        carousel.scrollTo({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
      
      // ===== Update dots =====
      function updateDots() {
        if (!dotsContainer) return;
        var totalPages = getTotalPages();
        var currentPage = getCurrentPage();
        
        dotsContainer.innerHTML = '';
        for (var i = 0; i < totalPages; i++) {
          var dot = document.createElement('button');
          dot.className = 'best-seller-dot' + (i === currentPage ? ' active' : '');
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
          dot.dataset.page = i;
          dot.addEventListener('click', function(e) {
            var page = parseInt(this.dataset.page);
            scrollToPage(page);
          });
          dotsContainer.appendChild(dot);
        }
      }
      
      // ===== Arrow functionality =====
      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var currentPage = getCurrentPage();
          if (currentPage > 0) {
            scrollToPage(currentPage - 1);
          }
        });
        
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var currentPage = getCurrentPage();
          var totalPages = getTotalPages();
          if (currentPage < totalPages - 1) {
            scrollToPage(currentPage + 1);
          }
        });
        
        // Update arrow states on scroll
        function updateArrowStates() {
          var currentPage = getCurrentPage();
          var totalPages = getTotalPages();
          prevBtn.disabled = currentPage === 0;
          nextBtn.disabled = currentPage >= totalPages - 1;
        }
        
        carousel.addEventListener('scroll', function() {
          updateDots();
          updateArrowStates();
        });
        
        window.addEventListener('resize', function() {
          updateDots();
          updateArrowStates();
        });
        
        setTimeout(function() {
          updateDots();
          updateArrowStates();
        }, 100);
      }
      
      // ===== Toast =====
      function showToast(message) {
        var toast = document.getElementById('best-seller-toast-' + sectionId);
        if (!toast) return;
        var msgEl = toast.querySelector('.best-seller-toast-message');
        if (msgEl) msgEl.textContent = message || 'Product added to cart!';
        toast.classList.add('active');
        clearTimeout(toast._timeout);
        toast._timeout = setTimeout(function() {
          toast.classList.remove('active');
        }, 3000);
      }
      
      // ===== Update Cart Count =====
      function updateCartCount() {
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var cartCount = document.querySelector('.cart-count, .header__cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }
          });
      }
      
      // ===== Get Cart Item for Variant =====
      function getCartItemForVariant(variantId) {
        return fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var items = cart.items || [];
            return items.find(function(item) { return item.variant_id == variantId; });
          });
      }
      
      // ===== Update All Cart Buttons =====
      function updateAllCartButtons(variantId, inCart, quantity) {
        section.querySelectorAll('.best-seller-add-to-cart').forEach(function(btn) {
          var vid = btn.getAttribute('data-variant-id');
          if (vid && vid == variantId) {
            var controls = btn.closest('.best-seller-cart-controls');
            var qtySelector = controls ? controls.querySelector('.best-seller-qty-selector') : null;
            var qtyInput = qtySelector ? qtySelector.querySelector('.best-seller-qty-input') : null;
            
            if (inCart && quantity > 0) {
              btn.style.display = 'none';
              if (qtySelector) {
                qtySelector.classList.add('active');
                if (qtyInput) qtyInput.value = quantity;
              }
            } else {
              btn.style.display = 'flex';
              btn.textContent = 'ADD TO CART';
              btn.classList.remove('added', 'loading');
              if (qtySelector) {
                qtySelector.classList.remove('active');
              }
            }
          }
        });
      }
      
      // ===== Handle Add to Cart =====
      function handleAddToCart(btn, variantId) {
        if (!variantId) return;
        
        btn.textContent = 'ADDING...';
        btn.classList.add('loading');
        
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function() {
          btn.textContent = 'ADDED ✓';
          btn.classList.remove('loading');
          btn.classList.add('added');
          showToast('Product added to cart!');
          updateCartCount();
          
          // Get actual quantity in cart
          getCartItemForVariant(variantId).then(function(item) {
            var qty = item ? item.quantity : 1;
            updateAllCartButtons(variantId, true, qty);
          });
          
          setTimeout(function() {
            btn.classList.remove('added');
          }, 2000);
        })
        .catch(function(error) {
          console.error('Error:', error);
          btn.textContent = 'TRY AGAIN';
          btn.classList.remove('loading');
          setTimeout(function() {
            btn.textContent = 'ADD TO CART';
          }, 2000);
        });
      }
      
      // ===== Quantity Minus Button =====
      section.querySelectorAll('.best-seller-qty-minus').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          var container = this.closest('.best-seller-qty-selector');
          var input = container.querySelector('.best-seller-qty-input');
          var variantId = input.getAttribute('data-variant-id') || container.getAttribute('data-variant-id');
          var currentVal = parseInt(input.value) || 1;
          
          // If quantity is 1, remove from cart completely
          if (currentVal === 1) {
            var formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', 0);
            
            fetch('/cart/change.js', {
              method: 'POST',
              body: formData
            })
            .then(function(response) { return response.json(); })
            .then(function() {
              updateCartCount();
              showToast('Product removed from cart!');
              
              // Find and restore the ADD TO CART button for this variant
              section.querySelectorAll('.best-seller-add-to-cart').forEach(function(b) {
                var vid = b.getAttribute('data-variant-id');
                if (vid && vid == variantId) {
                  b.style.display = 'flex';
                  b.textContent = 'ADD TO CART';
                  b.classList.remove('added', 'loading');
                  
                  var ctrls = b.closest('.best-seller-cart-controls');
                  var qtySel = ctrls ? ctrls.querySelector('.best-seller-qty-selector') : null;
                  if (qtySel) {
                    qtySel.classList.remove('active');
                    var inp = qtySel.querySelector('.best-seller-qty-input');
                    if (inp) inp.value = 1;
                  }
                }
              });
            })
            .catch(function(error) {
              console.error('Error removing from cart:', error);
            });
            return;
          }
          
          // If quantity > 1, decrease by 1
          var newVal = currentVal - 1;
          if (newVal < 0) return;
          input.value = newVal;
          
          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', newVal);
          
          fetch('/cart/change.js', {
            method: 'POST',
            body: formData
          })
          .then(function(response) { return response.json(); })
          .then(function() {
            updateCartCount();
            showToast('Cart updated!');
          });
        });
      });
      
      // ===== Quantity Plus Button =====
      section.querySelectorAll('.best-seller-qty-plus').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          var container = this.closest('.best-seller-qty-selector');
          var input = container.querySelector('.best-seller-qty-input');
          var variantId = input.getAttribute('data-variant-id') || container.getAttribute('data-variant-id');
          var currentVal = parseInt(input.value) || 1;
          var newVal = currentVal + 1;
          if (newVal > 99) newVal = 99;
          input.value = newVal;
          
          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', newVal);
          
          fetch('/cart/change.js', {
            method: 'POST',
            body: formData
          })
          .then(function(response) { return response.json(); })
          .then(function() {
            updateCartCount();
            showToast('Cart updated!');
          });
        });
      });
      
      // ===== Quantity Input Change =====
      section.querySelectorAll('.best-seller-qty-input').forEach(function(input) {
        input.addEventListener('change', function() {
          var val = parseInt(this.value) || 0;
          if (val < 0) val = 0;
          if (val > 99) val = 99;
          this.value = val;
          
          var container = this.closest('.best-seller-qty-selector');
          var variantId = this.getAttribute('data-variant-id') || container.getAttribute('data-variant-id');
          
          // If value is 0, remove from cart
          if (val === 0) {
            var formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', 0);
            
            fetch('/cart/change.js', {
              method: 'POST',
              body: formData
            })
            .then(function(response) { return response.json(); })
            .then(function() {
              updateCartCount();
              showToast('Product removed from cart!');
              container.classList.remove('active');
              section.querySelectorAll('.best-seller-add-to-cart').forEach(function(b) {
                var vid = b.getAttribute('data-variant-id');
                if (vid && vid == variantId) {
                  b.style.display = 'flex';
                  b.textContent = 'ADD TO CART';
                  b.classList.remove('added', 'loading');
                }
              });
            });
            return;
          }
          
          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', val);
          
          fetch('/cart/change.js', {
            method: 'POST',
            body: formData
          })
          .then(function(response) { return response.json(); })
          .then(function() {
            updateCartCount();
            showToast('Cart updated!');
          });
        });
      });
      
      // ===== Add to Cart Button Click =====
      section.querySelectorAll('.best-seller-add-to-cart').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          var variantId = this.getAttribute('data-variant-id');
          if (!variantId) {
            var card = this.closest('.best-seller-card');
            if (card) {
              variantId = card.getAttribute('data-variant-id');
            }
            if (!variantId) return;
          }
          
          // Check if button is disabled or already added
          if (this.disabled) return;
          
          handleAddToCart(this, variantId);
        });
      });
      
      // ===== Check Cart Status =====
      function checkCartStatus() {
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var cartItems = cart.items || [];
            
            section.querySelectorAll('.best-seller-card').forEach(function(card) {
              var variantId = card.getAttribute('data-variant-id');
              if (variantId) {
                var item = cartItems.find(function(item) { return item.variant_id == variantId; });
                var inCart = item && item.quantity > 0;
                var qty = item ? item.quantity : 0;
                
                var btn = card.querySelector('.best-seller-add-to-cart');
                var controls = card.querySelector('.best-seller-cart-controls');
                var qtySelector = controls ? controls.querySelector('.best-seller-qty-selector') : null;
                var qtyInput = qtySelector ? qtySelector.querySelector('.best-seller-qty-input') : null;
                
                if (btn && !btn.disabled) {
                  if (inCart && qty > 0) {
                    btn.style.display = 'none';
                    if (qtySelector) {
                      qtySelector.classList.add('active');
                      if (qtyInput) qtyInput.value = qty;
                    }
                  } else {
                    btn.style.display = 'flex';
                    btn.textContent = 'ADD TO CART';
                    btn.classList.remove('added', 'loading');
                    if (qtySelector) {
                      qtySelector.classList.remove('active');
                    }
                  }
                }
              }
            });
            
            // Update cart count
            updateCartCount();
          });
      }
      
      checkCartStatus();
      
      // ===== Section Visibility Check for Theme Editor =====
      if (window.Shopify && window.Shopify.section) {
        window.Shopify.section.registerType('best-seller-section-wrapper', {
          onLoad: function() {
            checkCartStatus();
            setTimeout(function() {
              updateDots();
            }, 200);
          },
          onUnload: function() {}
        });
      }
      
      // ===== Re-check cart status periodically (for safety) =====
      setInterval(function() {
        checkCartStatus();
      }, 5000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // ===== Filter Accordion =====
    document.querySelectorAll('.swata-filter-group-header').forEach(function(header) {
      header.addEventListener('click', function() {
        this.classList.toggle('open');
        var options = this.nextElementSibling;
        if (options) {
          options.classList.toggle('collapsed');
        }
      });
    });

    // ===== Mobile Filter Drawer =====
    var drawer = document.getElementById('filterDrawer');
    var toggleBtn = document.getElementById('mobileFilterToggle');
    var closeBtn = document.getElementById('filterDrawerClose');

    if (toggleBtn && drawer) {
      toggleBtn.addEventListener('click', function() {
        drawer.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    }
    if (closeBtn && drawer) {
      closeBtn.addEventListener('click', function() {
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
    if (drawer) {
      drawer.addEventListener('click', function(e) {
        if (e.target === drawer) {
          drawer.classList.remove('open');
          document.body.style.overflow = '';
        }
      });
    }

    // ===== Toggle Desktop Sidebar =====
    var toggleDesktop = document.getElementById('filterToggleDesktop');
    var sidebar = document.getElementById('filterSidebar');
    if (toggleDesktop && sidebar) {
      toggleDesktop.addEventListener('click', function() {
        sidebar.classList.toggle('hidden');
        this.innerHTML = sidebar.classList.contains('hidden') ? 
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="8" y1="18" x2="16" y2="18"/></svg> Show Filters' : 
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="8" y1="18" x2="16" y2="18"/></svg> Hide Filters';
      });
    }

    // ===== Sort =====
    var sortSelect = document.getElementById('sortSelect');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    // ===== Price Slider =====
    document.querySelectorAll('.swata-price-slider input[type="range"]').forEach(function(slider) {
      var rangeDisplay = slider.closest('.swata-price-slider').querySelector('.swata-price-range');
      if (rangeDisplay) {
        slider.addEventListener('input', function() {
          var min = this.min;
          var val = this.value;
          rangeDisplay.innerHTML = '<span>₹' + min + '</span><span>₹' + val + '+</span>';
        });
      }
    });

    // ===== Toast =====
    function showToast(message) {
      var toast = document.getElementById('cartToast');
      if (!toast) return;
      var msgEl = toast.querySelector('.swata-toast-message');
      if (msgEl) msgEl.textContent = message || 'Product added to cart!';
      toast.classList.add('active');
      clearTimeout(toast._timeout);
      toast._timeout = setTimeout(function() {
        toast.classList.remove('active');
      }, 3000);
    }

    // ===== Update Cart Count =====
    function updateCartCount() {
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var cartCount = document.querySelector('.cart-count, .header__cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          }
        });
    }

    // ===== Get Cart Item for Variant =====
    function getCartItemForVariant(variantId) {
      return fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var items = cart.items || [];
          return items.find(function(item) { return item.variant_id == variantId; });
        });
    }

    // ===== Update All Cart Buttons =====
    function updateAllCartButtons(variantId, inCart, quantity) {
      document.querySelectorAll('.add-to-cart-btn').forEach(function(btn) {
        var vid = btn.getAttribute('data-variant-id');
        if (vid && vid == variantId) {
          if (inCart && quantity > 0) {
            btn.textContent = 'REMOVE';
            btn.style.background = '#DC3545';
            btn.dataset.cartQuantity = quantity;
            // Show quantity selector
            var qtySelector = btn.closest('.swata-cart-controls').querySelector('.swata-qty-selector');
            if (qtySelector) {
              qtySelector.classList.add('active');
              var input = qtySelector.querySelector('.swata-qty-input');
              if (input) input.value = quantity;
            }
          } else {
            btn.textContent = 'ADD TO CART';
            btn.style.background = '#17687C';
            btn.dataset.cartQuantity = 0;
            var qtySelector = btn.closest('.swata-cart-controls').querySelector('.swata-qty-selector');
            if (qtySelector) {
              qtySelector.classList.remove('active');
            }
          }
        }
      });

      document.querySelectorAll('.add-to-cart-icon').forEach(function(btn) {
        var vid = btn.getAttribute('data-variant-id');
        if (vid && vid == variantId) {
          if (inCart && quantity > 0) {
            btn.classList.add('in-cart');
            btn.title = 'Remove from Cart';
          } else {
            btn.classList.remove('in-cart');
            btn.title = 'Add to Cart';
          }
        }
      });
    }

    // ===== Handle Add to Cart =====
    function handleAddToCart(btn, variantId, quantity) {
      if (!variantId) return;
      quantity = quantity || 1;
      
      var isIcon = btn.classList.contains('add-to-cart-icon');
      var originalText = btn.textContent;
      var originalBg = btn.style.background;
      
      // Check if already in cart (REMOVE state)
      if (btn.textContent.trim() === 'REMOVE' || btn.classList.contains('in-cart')) {
        // Remove from cart
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 0);
        
        fetch('/cart/change.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function() {
          if (isIcon) {
            btn.classList.remove('in-cart');
            btn.title = 'Add to Cart';
          } else {
            btn.textContent = 'ADD TO CART';
            btn.style.background = '#17687C';
          }
          updateCartCount();
          showToast('Product removed from cart!');
          updateAllCartButtons(variantId, false, 0);
        })
        .catch(function() {
          if (!isIcon) {
            btn.textContent = 'TRY AGAIN';
            btn.style.background = '#FF6B6B';
            setTimeout(function() {
              btn.textContent = originalText;
              btn.style.background = originalBg;
            }, 2000);
          }
        });
        return;
      }

      // Add to cart
      if (!isIcon) {
        btn.textContent = 'ADDING...';
        btn.style.background = '#7EC8B3';
        btn.disabled = true;
      }

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) { throw err; });
        }
        return response.json();
      })
      .then(function(cart) {
  if (isIcon) {
    btn.classList.add('in-cart');
    btn.title = 'Remove from Cart';
  } else {
    btn.textContent = 'REMOVE';
    btn.style.background = '#DC3545';
    btn.disabled = false;
  }

  showToast('Product added to cart!');

  // Update cart count
  updateCartCount();

  // IMPORTANT:
  // Refresh Horizon/FoxTheme cart drawer immediately
  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        open: true
      }
    })
  );

  // Get actual quantity in cart
  getCartItemForVariant(variantId).then(function(item) {
    var qty = item ? item.quantity : quantity;
    updateAllCartButtons(variantId, true, qty);
  });
})
      .catch(function(error) {
        console.error('Error:', error);
        if (!isIcon) {
          btn.textContent = 'TRY AGAIN';
          btn.style.background = '#FF6B6B';
          btn.disabled = false;
          setTimeout(function() {
            btn.textContent = originalText;
            btn.style.background = originalBg;
          }, 2000);
        }
      });
    }

    // ===== Quantity Controls =====
    document.querySelectorAll('.swata-qty-minus, .swata-qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var container = this.closest('.swata-qty-selector');
        var input = container.querySelector('.swata-qty-input');
        var variantId = input.getAttribute('data-variant-id') || container.getAttribute('data-variant-id');
        var currentVal = parseInt(input.value) || 1;
        var newVal = this.classList.contains('swata-qty-minus') ? currentVal - 1 : currentVal + 1;
        if (newVal < 1) newVal = 1;
        if (newVal > 99) newVal = 99;
        input.value = newVal;
        
        // Update cart with new quantity
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', newVal);
        
        fetch('/cart/change.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function() {
          updateCartCount();
          showToast('Cart updated!');
          // Update all buttons
          document.querySelectorAll('.add-to-cart-btn, .add-to-cart-icon').forEach(function(b) {
            var vid = b.getAttribute('data-variant-id');
            if (vid && vid == variantId) {
              if (b.classList.contains('add-to-cart-icon')) {
                if (newVal > 0) {
                  b.classList.add('in-cart');
                  b.title = 'Remove from Cart';
                } else {
                  b.classList.remove('in-cart');
                  b.title = 'Add to Cart';
                }
              } else {
                if (newVal > 0) {
                  b.textContent = 'REMOVE';
                  b.style.background = '#DC3545';
                } else {
                  b.textContent = 'ADD TO CART';
                  b.style.background = '#17687C';
                }
              }
            }
          });
          if (newVal === 0) {
            container.classList.remove('active');
          }
        });
      });
    });

    // ===== Quantity Input Change =====
    document.querySelectorAll('.swata-qty-input').forEach(function(input) {
      input.addEventListener('change', function() {
        var val = parseInt(this.value) || 1;
        if (val < 1) val = 1;
        if (val > 99) val = 99;
        this.value = val;
        
        var container = this.closest('.swata-qty-selector');
        var variantId = this.getAttribute('data-variant-id') || container.getAttribute('data-variant-id');
        
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', val);
        
        fetch('/cart/change.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function() {
          updateCartCount();
          showToast('Cart updated!');
          if (val === 0) {
            container.classList.remove('active');
          }
        });
      });
    });

    // ===== Add to Cart - Full Width Buttons =====
    document.querySelectorAll('.add-to-cart-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) {
          var card = this.closest('.swata-product-card');
          if (card) {
            variantId = card.getAttribute('data-variant-id');
          }
          if (!variantId) return;
        }
        handleAddToCart(this, variantId, 1);
      });
    });

    // ===== Add to Cart - Icon Buttons =====
    document.querySelectorAll('.add-to-cart-icon').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) {
          var card = this.closest('.swata-product-card');
          if (card) {
            variantId = card.getAttribute('data-variant-id');
          }
          if (!variantId) return;
        }
        handleAddToCart(this, variantId, 1);
      });
    });

    // ===== Check cart status =====
    function checkCartStatus() {
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var cartItems = cart.items || [];
          
          document.querySelectorAll('.add-to-cart-btn, .add-to-cart-icon').forEach(function(btn) {
            var variantId = btn.getAttribute('data-variant-id');
            if (variantId) {
              var item = cartItems.find(function(item) { return item.variant_id == variantId; });
              var inCart = item && item.quantity > 0;
              var qty = item ? item.quantity : 0;
              
              if (btn.classList.contains('add-to-cart-icon')) {
                if (inCart) {
                  btn.classList.add('in-cart');
                  btn.title = 'Remove from Cart';
                } else {
                  btn.classList.remove('in-cart');
                  btn.title = 'Add to Cart';
                }
              } else {
                if (!btn.disabled) {
                  if (inCart) {
                    btn.textContent = 'REMOVE';
                    btn.style.background = '#DC3545';
                  } else {
                    btn.textContent = 'ADD TO CART';
                    btn.style.background = '#17687C';
                  }
                }
              }
              
              // Update quantity selector
              var controls = btn.closest('.swata-cart-controls');
              if (controls) {
                var qtySelector = controls.querySelector('.swata-qty-selector');
                if (qtySelector) {
                  if (inCart) {
                    qtySelector.classList.add('active');
                    var input = qtySelector.querySelector('.swata-qty-input');
                    if (input) input.value = qty;
                  } else {
                    qtySelector.classList.remove('active');
                  }
                }
              }
            }
          });
        });
    }

    checkCartStatus();

    // ===== Quick View & Choose Options =====
    var quickviewOverlay = document.getElementById('quickViewOverlay');
    var quickviewContent = document.getElementById('quickViewContent');
    var quickviewClose = document.getElementById('quickViewClose');

    function openQuickView(handle) {
      if (!quickviewOverlay || !quickviewContent) return;
      quickviewContent.innerHTML = '<div class="swata-quickview-loading">Loading product...</div>';
      quickviewOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';

      fetch('/products/' + handle + '.js')
        .then(function(response) { return response.json(); })
        .then(function(productData) {
          if (productData) {
            var variant = productData.variants[0] || {};
            var price = variant.price / 100 || 0;
            var comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
            var onSale = comparePrice && comparePrice > price;
            var savings = onSale ? Math.round((comparePrice - price) / comparePrice * 100) : 0;
            var rating = (Math.random() * 0.8 + 4.2).toFixed(1);
            
            var htmlContent = `
              <div class="swata-quickview-product">
                <div class="swata-quickview-image">
                  <img src="${productData.featured_image || 'https://via.placeholder.com/400'}" alt="${productData.title}">
                </div>
                <div class="swata-quickview-details">
                  <p class="qv-brand">${productData.vendor || 'SWATA'}</p>
                  <h2 class="qv-title">${productData.title}</h2>
                  <p class="qv-rating">★★★★★ (${rating})</p>
                  <div class="qv-price">
                    ₹${price.toFixed(2)}
                    ${onSale ? `<span class="qv-old">₹${comparePrice.toFixed(2)}</span>` : ''}
                    ${onSale ? `<span style="color:#17687C;font-size:14px;margin-left:8px;">Save ${savings}%</span>` : ''}
                  </div>
                  <p class="qv-desc">${productData.description || 'Hydrating & Gentle skincare solution.'}</p>
                  <button class="qv-add-btn add-to-cart-btn" data-variant-id="${variant.id || ''}">ADD TO CART</button>
                </div>
              </div>
            `;
            quickviewContent.innerHTML = htmlContent;
            
            var qvAddBtn = quickviewContent.querySelector('.qv-add-btn');
            if (qvAddBtn) {
              qvAddBtn.addEventListener('click', function(e) {
                e.preventDefault();
                var vid = this.getAttribute('data-variant-id');
                if (!vid) return;
                
                var mainBtn = document.querySelector('.swata-add-to-cart[data-variant-id="' + vid + '"]');
                if (mainBtn) {
                  mainBtn.click();
                } else {
                  var fd = new FormData();
                  fd.append('id', vid);
                  fd.append('quantity', 1);
                  fetch('/cart/add.js', { method: 'POST', body: fd })
                    .then(function(res) { return res.json(); })
                    .then(function() { 
                      showToast('Product added to cart!');
                      updateCartCount();
                      checkCartStatus();
                    });
                }
                quickviewOverlay.classList.remove('active');
                document.body.style.overflow = '';
              });
            }
          } else {
            quickviewContent.innerHTML = `
              <div style="text-align:center;padding:20px;">
                <p style="color:#6B7280;">Unable to load product details.</p>
                <a href="/products/${handle}" class="swata-btn-primary" style="display:inline-block;margin-top:12px;">View Product</a>
              </div>
            `;
          }
        })
        .catch(function() {
          quickviewContent.innerHTML = `
            <div style="text-align:center;padding:20px;">
              <p style="color:#6B7280;">Unable to load product details.</p>
              <a href="/products/${handle}" class="swata-btn-primary" style="display:inline-block;margin-top:12px;">View Product</a>
            </div>
          `;
        });
    }

    document.querySelectorAll('.quick-view-btn, .choose-options-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = this.getAttribute('data-handle');
        if (handle) { 
          openQuickView(handle); 
        }
      });
    });

    if (quickviewClose) {
      quickviewClose.addEventListener('click', function() {
        quickviewOverlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
    if (quickviewOverlay) {
      quickviewOverlay.addEventListener('click', function(e) {
        if (e.target === this) {
          this.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (quickviewOverlay && quickviewOverlay.classList.contains('active')) {
          quickviewOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
        if (drawer && drawer.classList.contains('open')) {
          drawer.classList.remove('open');
          document.body.style.overflow = '';
        }
      }
    });

    // ===== Clear Filters =====
    document.querySelectorAll('.swata-clear-filters').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var checkboxes = document.querySelectorAll('.swata-filter-option input[type="checkbox"]');
        checkboxes.forEach(function(cb) { cb.checked = false; });
        var sliders = document.querySelectorAll('.swata-price-slider input[type="range"]');
        sliders.forEach(function(slider) {
          slider.value = slider.max;
          var rangeDisplay = slider.closest('.swata-price-slider').querySelector('.swata-price-range');
          if (rangeDisplay) {
            rangeDisplay.innerHTML = '<span>₹' + slider.min + '</span><span>₹' + slider.max + '+</span>';
          }
        });
        var url = new URL(window.location.href);
        url.searchParams.delete('filter');
        url.searchParams.delete('sort_by');
        window.location.href = url.toString();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swata-custom-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Get all section instances
    document.querySelectorAll('.swata-collection-wrap').forEach(function(wrap) {
      var sectionId = wrap.getAttribute('data-section-id');
      if (!sectionId) return;
      
      // ===== Filter Accordion =====
      wrap.querySelectorAll('.swata-filter-group-header').forEach(function(header) {
        header.addEventListener('click', function() {
          this.classList.toggle('open');
          var options = this.nextElementSibling;
          if (options) {
            options.classList.toggle('collapsed');
          }
        });
      });

      // ===== Mobile Filter Drawer =====
      var drawer = document.getElementById('filterDrawer-' + sectionId);
      var toggleBtn = document.getElementById('mobileFilterToggle-' + sectionId);
      var closeBtn = document.getElementById('filterDrawerClose-' + sectionId);

      if (toggleBtn && drawer) {
        toggleBtn.addEventListener('click', function(e) {
          e.preventDefault();
          drawer.classList.add('open');
          document.body.style.overflow = 'hidden';
        });
      }
      if (closeBtn && drawer) {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          drawer.classList.remove('open');
          document.body.style.overflow = '';
        });
      }
      if (drawer) {
        drawer.addEventListener('click', function(e) {
          if (e.target === drawer) {
            drawer.classList.remove('open');
            document.body.style.overflow = '';
          }
        });
      }

      // ===== Toggle Desktop Sidebar =====
      var toggleDesktop = document.getElementById('filterToggleDesktop-' + sectionId);
      var sidebar = document.getElementById('filterSidebar-' + sectionId);
      if (toggleDesktop && sidebar) {
        toggleDesktop.addEventListener('click', function(e) {
          e.preventDefault();
          sidebar.classList.toggle('hidden');
          this.innerHTML = sidebar.classList.contains('hidden') ? 
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="8" y1="18" x2="16" y2="18"/></svg> Show Filters' : 
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="8" y1="18" x2="16" y2="18"/></svg> Hide Filters';
        });
      }

      // ===== Sort =====
      var sortSelect = document.getElementById('sortSelect-' + sectionId);
      if (sortSelect) {
        sortSelect.addEventListener('change', function() {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', this.value);
          window.location.href = url.toString();
        });
      }

      // ===== Price Slider =====
      wrap.querySelectorAll('.swata-price-slider input[type="range"]').forEach(function(slider) {
        var rangeDisplay = slider.closest('.swata-price-slider').querySelector('.swata-price-range');
        if (rangeDisplay) {
          slider.addEventListener('input', function() {
            var min = this.min;
            var val = this.value;
            rangeDisplay.innerHTML = '<span>₹' + min + '</span><span>₹' + val + '+</span>';
          });
        }
      });

      // ===== Toast =====
      function showToast(message) {
        var toast = document.getElementById('cartToast-' + sectionId);
        if (!toast) return;
        var msgEl = toast.querySelector('.swata-toast-message');
        if (msgEl) msgEl.textContent = message || 'Product added to cart!';
        toast.classList.add('active');
        clearTimeout(toast._timeout);
        toast._timeout = setTimeout(function() {
          toast.classList.remove('active');
        }, 3000);
      }

      // ===== Update Cart Count =====
      function updateCartCount() {
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var cartCount = document.querySelector('.cart-count, .header__cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }
          });
      }

      // ===== Get Cart Item for Variant =====
      function getCartItemForVariant(variantId) {
        return fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var items = cart.items || [];
            return items.find(function(item) { return item.variant_id == variantId; });
          });
      }

      // ===== Update All Cart Buttons =====
      function updateAllCartButtons(variantId, inCart, quantity) {
        wrap.querySelectorAll('.add-to-cart-btn').forEach(function(btn) {
          var vid = btn.getAttribute('data-variant-id');
          if (vid && vid == variantId) {
            if (inCart && quantity > 0) {
              btn.textContent = 'REMOVE';
              btn.style.background = '#DC3545';
              btn.dataset.cartQuantity = quantity;
              // Show quantity selector
              var qtySelector = btn.closest('.swata-cart-controls').querySelector('.swata-qty-selector');
              if (qtySelector) {
                qtySelector.classList.add('active');
                var input = qtySelector.querySelector('.swata-qty-input');
                if (input) input.value = quantity;
              }
            } else {
              btn.textContent = 'ADD TO CART';
              btn.style.background = '#17687C';
              btn.dataset.cartQuantity = 0;
              var qtySelector = btn.closest('.swata-cart-controls').querySelector('.swata-qty-selector');
              if (qtySelector) {
                qtySelector.classList.remove('active');
              }
            }
          }
        });

        wrap.querySelectorAll('.add-to-cart-icon').forEach(function(btn) {
          var vid = btn.getAttribute('data-variant-id');
          if (vid && vid == variantId) {
            if (inCart && quantity > 0) {
              btn.classList.add('in-cart');
              btn.title = 'Remove from Cart';
            } else {
              btn.classList.remove('in-cart');
              btn.title = 'Add to Cart';
            }
          }
        });
      }

      // ===== Handle Add to Cart =====
      function handleAddToCart(btn, variantId, quantity) {
        if (!variantId) return;
        quantity = quantity || 1;
        
        var isIcon = btn.classList.contains('add-to-cart-icon');
        var originalText = btn.textContent;
        var originalBg = btn.style.background;
        
        // Check if already in cart (REMOVE state)
        if (btn.textContent.trim() === 'REMOVE' || btn.classList.contains('in-cart')) {
          // Remove from cart
          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', 0);
          
          fetch('/cart/change.js', {
            method: 'POST',
            body: formData
          })
          .then(function(response) { return response.json(); })
          .then(function() {
            if (isIcon) {
              btn.classList.remove('in-cart');
              btn.title = 'Add to Cart';
            } else {
              btn.textContent = 'ADD TO CART';
              btn.style.background = '#17687C';
            }
            updateCartCount();
            showToast('Product removed from cart!');
            updateAllCartButtons(variantId, false, 0);
          })
          .catch(function() {
            if (!isIcon) {
              btn.textContent = 'TRY AGAIN';
              btn.style.background = '#FF6B6B';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.style.background = originalBg;
              }, 2000);
            }
          });
          return;
        }

        // Add to cart
        if (!isIcon) {
          btn.textContent = 'ADDING...';
          btn.style.background = '#7EC8B3';
          btn.disabled = true;
        }

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) { throw err; });
          }
          return response.json();
        })
        .then(function(cart) {
          if (isIcon) {
            btn.classList.add('in-cart');
            btn.title = 'Remove from Cart';
          } else {
            btn.textContent = 'REMOVE';
            btn.style.background = '#DC3545';
            btn.disabled = false;
          }
          showToast('Product added to cart!');
          updateCartCount();
          // Get actual quantity in cart
          getCartItemForVariant(variantId).then(function(item) {
            var qty = item ? item.quantity : quantity;
            updateAllCartButtons(variantId, true, qty);
          });
        })
        .catch(function(error) {
          console.error('Error:', error);
          if (!isIcon) {
            btn.textContent = 'TRY AGAIN';
            btn.style.background = '#FF6B6B';
            btn.disabled = false;
            setTimeout(function() {
              btn.textContent = originalText;
              btn.style.background = originalBg;
            }, 2000);
          }
        });
      }

      // ===== Quantity Controls =====
      wrap.querySelectorAll('.swata-qty-minus, .swata-qty-plus').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var container = this.closest('.swata-qty-selector');
          var input = container.querySelector('.swata-qty-input');
          var variantId = input.getAttribute('data-variant-id') || container.getAttribute('data-variant-id');
          var currentVal = parseInt(input.value) || 1;
          var newVal = this.classList.contains('swata-qty-minus') ? currentVal - 1 : currentVal + 1;
          if (newVal < 1) newVal = 1;
          if (newVal > 99) newVal = 99;
          input.value = newVal;
          
          // Update cart with new quantity
          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', newVal);
          
          fetch('/cart/change.js', {
            method: 'POST',
            body: formData
          })
          .then(function(response) { return response.json(); })
          .then(function() {
            updateCartCount();
            showToast('Cart updated!');
            // Update all buttons in this section
            wrap.querySelectorAll('.add-to-cart-btn, .add-to-cart-icon').forEach(function(b) {
              var vid = b.getAttribute('data-variant-id');
              if (vid && vid == variantId) {
                if (b.classList.contains('add-to-cart-icon')) {
                  if (newVal > 0) {
                    b.classList.add('in-cart');
                    b.title = 'Remove from Cart';
                  } else {
                    b.classList.remove('in-cart');
                    b.title = 'Add to Cart';
                  }
                } else {
                  if (newVal > 0) {
                    b.textContent = 'REMOVE';
                    b.style.background = '#DC3545';
                  } else {
                    b.textContent = 'ADD TO CART';
                    b.style.background = '#17687C';
                  }
                }
              }
            });
            if (newVal === 0) {
              container.classList.remove('active');
            }
          });
        });
      });

      // ===== Quantity Input Change =====
      wrap.querySelectorAll('.swata-qty-input').forEach(function(input) {
        input.addEventListener('change', function() {
          var val = parseInt(this.value) || 1;
          if (val < 1) val = 1;
          if (val > 99) val = 99;
          this.value = val;
          
          var container = this.closest('.swata-qty-selector');
          var variantId = this.getAttribute('data-variant-id') || container.getAttribute('data-variant-id');
          
          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', val);
          
          fetch('/cart/change.js', {
            method: 'POST',
            body: formData
          })
          .then(function(response) { return response.json(); })
          .then(function() {
            updateCartCount();
            showToast('Cart updated!');
            if (val === 0) {
              container.classList.remove('active');
            }
          });
        });
      });

      // ===== Add to Cart - Full Width Buttons =====
      wrap.querySelectorAll('.add-to-cart-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = this.getAttribute('data-variant-id');
          if (!variantId) {
            var card = this.closest('.swata-product-card');
            if (card) {
              variantId = card.getAttribute('data-variant-id');
            }
            if (!variantId) return;
          }
          handleAddToCart(this, variantId, 1);
        });
      });

      // ===== Add to Cart - Icon Buttons =====
      wrap.querySelectorAll('.add-to-cart-icon').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = this.getAttribute('data-variant-id');
          if (!variantId) {
            var card = this.closest('.swata-product-card');
            if (card) {
              variantId = card.getAttribute('data-variant-id');
            }
            if (!variantId) return;
          }
          handleAddToCart(this, variantId, 1);
        });
      });

      // ===== Check cart status for this section =====
      function checkCartStatus() {
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var cartItems = cart.items || [];
            
            wrap.querySelectorAll('.add-to-cart-btn, .add-to-cart-icon').forEach(function(btn) {
              var variantId = btn.getAttribute('data-variant-id');
              if (variantId) {
                var item = cartItems.find(function(item) { return item.variant_id == variantId; });
                var inCart = item && item.quantity > 0;
                var qty = item ? item.quantity : 0;
                
                if (btn.classList.contains('add-to-cart-icon')) {
                  if (inCart) {
                    btn.classList.add('in-cart');
                    btn.title = 'Remove from Cart';
                  } else {
                    btn.classList.remove('in-cart');
                    btn.title = 'Add to Cart';
                  }
                } else {
                  if (!btn.disabled) {
                    if (inCart) {
                      btn.textContent = 'REMOVE';
                      btn.style.background = '#DC3545';
                    } else {
                      btn.textContent = 'ADD TO CART';
                      btn.style.background = '#17687C';
                    }
                  }
                }
                
                // Update quantity selector
                var controls = btn.closest('.swata-cart-controls');
                if (controls) {
                  var qtySelector = controls.querySelector('.swata-qty-selector');
                  if (qtySelector) {
                    if (inCart) {
                      qtySelector.classList.add('active');
                      var input = qtySelector.querySelector('.swata-qty-input');
                      if (input) input.value = qty;
                    } else {
                      qtySelector.classList.remove('active');
                    }
                  }
                }
              }
            });
          });
      }

      checkCartStatus();

      // ===== Quick View & Choose Options =====
      var quickviewOverlay = document.getElementById('quickViewOverlay-' + sectionId);
      var quickviewContent = document.getElementById('quickViewContent-' + sectionId);
      var quickviewClose = document.getElementById('quickViewClose-' + sectionId);

      function openQuickView(handle) {
        if (!quickviewOverlay || !quickviewContent) return;
        quickviewContent.innerHTML = '<div class="swata-quickview-loading">Loading product...</div>';
        quickviewOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';

        fetch('/products/' + handle + '.js')
          .then(function(response) { return response.json(); })
          .then(function(productData) {
            if (productData) {
              var variant = productData.variants[0] || {};
              var price = variant.price / 100 || 0;
              var comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
              var onSale = comparePrice && comparePrice > price;
              var savings = onSale ? Math.round((comparePrice - price) / comparePrice * 100) : 0;
              var rating = (Math.random() * 0.8 + 4.2).toFixed(1);
              
              var htmlContent = `
                <div class="swata-quickview-product">
                  <div class="swata-quickview-image">
                    <img src="${productData.featured_image || 'https://via.placeholder.com/400'}" alt="${productData.title}">
                  </div>
                  <div class="swata-quickview-details">
                    <p class="qv-brand">${productData.vendor || 'SWATA'}</p>
                    <h2 class="qv-title">${productData.title}</h2>
                    <p class="qv-rating">★★★★★ (${rating})</p>
                    <div class="qv-price">
                      ₹${price.toFixed(2)}
                      ${onSale ? `<span class="qv-old">₹${comparePrice.toFixed(2)}</span>` : ''}
                      ${onSale ? `<span style="color:#17687C;font-size:14px;margin-left:8px;">Save ${savings}%</span>` : ''}
                    </div>
                    <p class="qv-desc">${productData.description || 'Hydrating & Gentle skincare solution.'}</p>
                    <button class="qv-add-btn add-to-cart-btn" data-variant-id="${variant.id || ''}" data-section-id="${sectionId}">ADD TO CART</button>
                  </div>
                </div>
              `;
              quickviewContent.innerHTML = htmlContent;
              
              var qvAddBtn = quickviewContent.querySelector('.qv-add-btn');
              if (qvAddBtn) {
                qvAddBtn.addEventListener('click', function(e) {
                  e.preventDefault();
                  var vid = this.getAttribute('data-variant-id');
                  if (!vid) return;
                  
                  var mainBtn = wrap.querySelector('.swata-add-to-cart[data-variant-id="' + vid + '"]');
                  if (mainBtn) {
                    mainBtn.click();
                  } else {
                    var fd = new FormData();
                    fd.append('id', vid);
                    fd.append('quantity', 1);
                    fetch('/cart/add.js', { method: 'POST', body: fd })
                      .then(function(res) { return res.json(); })
                      .then(function() { 
                        showToast('Product added to cart!');
                        updateCartCount();
                        checkCartStatus();
                      });
                  }
                  quickviewOverlay.classList.remove('active');
                  document.body.style.overflow = '';
                });
              }
            } else {
              quickviewContent.innerHTML = `
                <div style="text-align:center;padding:20px;">
                  <p style="color:#6B7280;">Unable to load product details.</p>
                  <a href="/products/${handle}" class="swata-btn-primary" style="display:inline-block;margin-top:12px;">View Product</a>
                </div>
              `;
            }
          })
          .catch(function() {
            quickviewContent.innerHTML = `
              <div style="text-align:center;padding:20px;">
                <p style="color:#6B7280;">Unable to load product details.</p>
                <a href="/products/${handle}" class="swata-btn-primary" style="display:inline-block;margin-top:12px;">View Product</a>
              </div>
            `;
          });
      }

      wrap.querySelectorAll('.choose-options-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var handle = this.getAttribute('data-handle');
          if (handle) { 
            openQuickView(handle); 
          }
        });
      });

      if (quickviewClose) {
        quickviewClose.addEventListener('click', function(e) {
          e.preventDefault();
          quickviewOverlay.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
      if (quickviewOverlay) {
        quickviewOverlay.addEventListener('click', function(e) {
          if (e.target === this) {
            this.classList.remove('active');
            document.body.style.overflow = '';
          }
        });
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          if (quickviewOverlay && quickviewOverlay.classList.contains('active')) {
            quickviewOverlay.classList.remove('active');
            document.body.style.overflow = '';
          }
          if (drawer && drawer.classList.contains('open')) {
            drawer.classList.remove('open');
            document.body.style.overflow = '';
          }
        }
      });

      // ===== Clear Filters =====
      wrap.querySelectorAll('.swata-clear-filters').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var checkboxes = wrap.querySelectorAll('.swata-filter-option input[type="checkbox"]');
          checkboxes.forEach(function(cb) { cb.checked = false; });
          var sliders = wrap.querySelectorAll('.swata-price-slider input[type="range"]');
          sliders.forEach(function(slider) {
            slider.value = slider.max;
            var rangeDisplay = slider.closest('.swata-price-slider').querySelector('.swata-price-range');
            if (rangeDisplay) {
              rangeDisplay.innerHTML = '<span>₹' + slider.min + '</span><span>₹' + slider.max + '+</span>';
            }
          });
          var url = new URL(window.location.href);
          url.searchParams.delete('filter');
          url.searchParams.delete('sort_by');
          window.location.href = url.toString();
        });
      });

      // ===== Apply Filters button =====
      var applyBtn = document.getElementById('applyFilters-' + sectionId);
      if (applyBtn) {
        applyBtn.addEventListener('click', function(e) {
          e.preventDefault();
          // Close drawer
          if (drawer) {
            drawer.classList.remove('open');
            document.body.style.overflow = '';
          }
          // Actually apply filters by submitting the form
          // Since we're using standard filter checkboxes, we need to submit the filter form
          var filterForm = wrap.querySelector('form[action*="collections"]');
          if (filterForm) {
            filterForm.submit();
          } else {
            // If no form, just reload with filter params
            var url = new URL(window.location.href);
            var checkboxes = wrap.querySelectorAll('.swata-filter-option input[type="checkbox"]:checked');
            var filterParams = [];
            checkboxes.forEach(function(cb) {
              var name = cb.getAttribute('name');
              var value = cb.getAttribute('value');
              if (name && value) {
                filterParams.push(name + '=' + encodeURIComponent(value));
              }
            });
            if (filterParams.length > 0) {
              url.searchParams.set('filter', filterParams.join('&'));
            } else {
              url.searchParams.delete('filter');
            }
            window.location.href = url.toString();
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
